import React, { useState } from 'react';
import { TMDB_IMG } from '../api/api';

const fameBadge = (popularity) => {
  if (popularity >= 15) return { label: 'Famous', color: '#ff6b35' };
  if (popularity >= 5)  return { label: 'Known',  color: '#1a1a1a' };
  return                       { label: 'Niche',  color: '#888' };
};

const ActorCard = ({ actorName, actorRole, actorImgUrl, popularity }) => {
  const [imgError, setImgError] = useState(false);
  const badge = popularity != null ? fameBadge(popularity) : null;

  return (
    <div className="bg-white border-[3px] border-[#1a1a1a] rounded-xl p-3 flex items-center gap-3 shadow-[3px_3px_0_#1a1a1a]">
      {actorImgUrl && !imgError ? (
        <img
          src={`${TMDB_IMG}${actorImgUrl}`}
          alt={actorName}
          onError={() => setImgError(true)}
          className="w-10 h-10 rounded-full object-cover border-2 border-[#1a1a1a] flex-shrink-0"
        />
      ) : (
        <div className="w-10 h-10 rounded-full bg-[#f0e6d3] border-2 border-[#1a1a1a] flex-shrink-0 flex items-center justify-center text-lg">
          🎭
        </div>
      )}
      <div className="text-left flex-1">
        <p className="text-sm font-bold text-[#1a1a1a]">{actorName}</p>
        <p className="text-xs text-[#888]">{actorRole}</p>
      </div>
      {badge && (
        <span
          className="text-[9px] font-black uppercase tracking-wider px-2 py-0.5 rounded border-2 flex-shrink-0"
          style={{ color: badge.color, borderColor: badge.color }}
        >
          {badge.label}
        </span>
      )}
    </div>
  );
};

export default ActorCard;
